import Cookies from 'js-cookie'
import VueI18n from 'vue-i18n'

const messages = {
  en: require('../consts/i18n/zh'),
  jp: require('../consts/i18n/jp')
}

let i18n = null

let createI18n = () => {
  if (i18n !== null) return i18n
  else {
    i18n = new VueI18n({
      locale: Cookies.get('language') || 'zh', // デフォルト言語設定
      messages
    })
    return i18n
  }
}

let getI18n = () => {
  return i18n
}

export default {
  createI18n: createI18n,
  getI18n: getI18n
}



// WEBPACK FOOTER //
// ./src/scripts/services/I18nClient.js